module.exports = __webpack_public_path__ + "img/QRIcon.0fc91c4f.png";